// ==========================================================================
// くちびるLABO - Card Carousel Module
// ==========================================================================

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import $ from 'jquery';
import { laboCards } from '../../data/labo-cards-data.js';

class Labo {
	constructor() {
		this.$container = $('.labo');
		if (!this.$container.length) return;

		this.$wrapper = this.$container.find('.labo_swiper .swiper-wrapper');
		if (!this.$wrapper.length) return;

		this.renderCards();
		this.initSwiper();
		this.bindCardClick();
	}

	renderCards() {
		const html = laboCards.map((card) => this.cardTemplate(card)).join('');
		this.$wrapper.html(html);
	}

	cardTemplate(card) {
		const alt = `唇のお悩み ${card.number} ${this.stripHtmlTags(card.title)}`;
		return `
			<div class="swiper-slide labo_card" data-modal-id="${card.modalId}" data-card-id="${card.id}">
				<img class="labo_card_image" src="${card.image}" alt="${this.escapeAttr(alt)}" loading="lazy">
				<div class="labo_card_icon" aria-hidden="true">
					<img src="./assets/images/products/i_plus.svg" alt="" loading="lazy">
				</div>
			</div>
		`;
	}

	initSwiper() {
		this.swiper = new Swiper('.labo_swiper', {
			modules: [Navigation, Pagination],
			slidesPerView: 'auto',
			spaceBetween: 30,
			centeredSlides: false,
			grabCursor: true,
			navigation: {
				nextEl: '.labo_btn--next',
				prevEl: '.labo_btn--prev',
			},
			pagination: {
				el: '.labo_pagination',
				clickable: true,
			},
			breakpoints: {
				0: {
					slidesPerView: 'auto',
					spaceBetween: 15,
					centerInsufficientSlides: true,
				},
				768: {
					slidesPerView: 'auto',
					spaceBetween: 30,
					centerInsufficientSlides: true,
				},
			},
		});
	}

	bindCardClick() {
		this.$container.on('click', '.labo_card', (e) => {
			const $card = $(e.currentTarget);
			const modalId = $card.data('modal-id');
			if (!modalId) return;
			if (typeof window.openLaboModal === 'function') {
				window.openLaboModal(modalId);
			} else {
				console.warn('[labo] openLaboModal not ready yet:', modalId);
			}
		});
	}

	stripHtmlTags(str) {
		if (!str) return '';
		return String(str).replace(/<[^>]*>/g, '');
	}

	escapeAttr(str) {
		if (!str) return '';
		return String(str).replace(/"/g, '&quot;');
	}
}

$(() => {
	new Labo();
});

export default Labo;
